import { useContext } from "react";
import { UsersContext } from "../contexts/users-context";

export const useUsers = () => useContext(UsersContext);
